'use strict';

module.exports = function (row, column) {

  if (column.indexOf('.') === -1) return row[column];

  var p = column.split('.');

  var value = row[p[0]];

  if (!value) return '';

  for (var i = 1; i < p.length; i++) {
    value = value[p[i]];

    // If the nested structure doesn't exist return an empty string
    if (typeof value === 'undefined') return '';
  }

  return value;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/get-value.js
// module id = 1467
// module chunks = 0